__turbopack_context__.v({
  "body": "BottomSheet-module-scss-module__zKM-6a__body",
  "closeButton": "BottomSheet-module-scss-module__zKM-6a__closeButton",
  "column": "BottomSheet-module-scss-module__zKM-6a__column",
  "container": "BottomSheet-module-scss-module__zKM-6a__container",
  "content": "BottomSheet-module-scss-module__zKM-6a__content",
  "content_scroller": "BottomSheet-module-scss-module__zKM-6a__content_scroller",
  "cta": "BottomSheet-module-scss-module__zKM-6a__cta",
  "cta_wrap": "BottomSheet-module-scss-module__zKM-6a__cta_wrap",
  "full": "BottomSheet-module-scss-module__zKM-6a__full",
  "header": "BottomSheet-module-scss-module__zKM-6a__header",
  "hug": "BottomSheet-module-scss-module__zKM-6a__hug",
  "row": "BottomSheet-module-scss-module__zKM-6a__row",
  "sheet": "BottomSheet-module-scss-module__zKM-6a__sheet",
  "title": "BottomSheet-module-scss-module__zKM-6a__title",
  "wrap": "BottomSheet-module-scss-module__zKM-6a__wrap",
});
